// FAQ accordion
    function toggleFaq(btn) {
      const item = btn.closest('.faq__item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq__item.open').forEach(el => el.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    }

    // Dynamic batch counter — varies slightly per session so it feels live
    (function() {
      const base = 318;
      const variance = Math.floor(Math.random() * 24); // 318-341
      const count = base + variance;
      document.querySelectorAll('.hero__social-proof-text strong').forEach(el => {
        el.textContent = '1322 hundeejere';
      });
      // Batch bar fill — slightly different each visit (58-68% full)
      const fill = document.querySelector('.batch-bar__fill');
      if (fill) {
        const pct = 58 + Math.floor(Math.random() * 10);
        const remaining = Math.round((100 - pct) * 2.5); // approx slots from 250
        const countEl = document.querySelector('.batch-bar__count');
        if (countEl) countEl.textContent = remaining + ' pladser';
        const batchObs = new IntersectionObserver(entries => {
          if (entries[0].isIntersecting) {
            setTimeout(() => fill.style.width = pct + '%', 200);
            batchObs.disconnect();
          }
        }, { threshold: 0.5 });
        if (fill.closest('.batch-bar')) batchObs.observe(fill.closest('.batch-bar'));
      }
    })();

    // Header scroll
    const header = document.getElementById('SiteHeader');
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    }, { passive: true });

    // Mobile nav
    const btn = document.getElementById('HamburgerBtn');
    const nav = document.getElementById('MobileNav');
    btn.addEventListener('click', () => {
      const open = nav.style.display === 'none' || nav.style.display === '';
      nav.style.display = open ? 'block' : 'none';
      btn.setAttribute('aria-expanded', open);
    });

    // Smooth scroll
    document.querySelectorAll('a[href^="#"]').forEach(a => {
      a.addEventListener('click', e => {
        const target = document.querySelector(a.getAttribute('href'));
        if (target) {
          e.preventDefault();
          const top = target.getBoundingClientRect().top + window.scrollY - 80;
          window.scrollTo({ top, behavior: 'smooth' });
          nav.style.display = 'none';
        }
      });
    });

    // Scroll reveal
    const reveals = document.querySelectorAll('.reveal');
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(el => io.observe(el));

    // Signup forms — submit to Shopify's customer/newsletter endpoint via fetch
    // so the page doesn't reload; falls back to a real form submit if the
    // request fails, which lets Shopify's own {% form %} error handling take over.
    function submitSignupForm(form, { successEl, inputEl, submitBtn, submittedLabel }) {
      fetch(form.action, { method: 'POST', body: new FormData(form) })
        .then(res => {
          if (!res.ok) throw new Error('Signup request failed');
          successEl.style.display = 'block';
          inputEl.value = '';
          if (submitBtn && submittedLabel) submitBtn.textContent = submittedLabel;
          updateCounter();
        })
        .catch(() => {
          form.submit();
        });
    }
    function handleSignup(e) {
      e.preventDefault();
      const form = e.target;
      submitSignupForm(form, {
        successEl: document.getElementById('SignupSuccess'),
        inputEl: document.getElementById('EmailInput'),
      });
    }
    function handleHeroSignup(e) {
      e.preventDefault();
      const form = e.target;
      submitSignupForm(form, {
        successEl: document.getElementById('HeroSuccess'),
        inputEl: document.getElementById('HeroEmail'),
        submitBtn: form.querySelector('button'),
        submittedLabel: '✓ TILMELDT',
      });
    }
    function handleFooterSignup(e) {
      e.preventDefault();
      const form = e.target;
      submitSignupForm(form, {
        successEl: document.getElementById('FooterNewsletterSuccess'),
        inputEl: document.getElementById('FooterEmail'),
      });
    }
    function updateCounter() {
      // Simulate live counter increment
      const els = document.querySelectorAll('.hero__social-proof-text strong, .batch-bar__count');
      els.forEach(el => {
        const current = parseInt(el.textContent.replace(/\D/g,''));
        el.textContent = el.textContent.replace(String(current), String(current + 1));
      });
    }

    // Show sticky CTA after scrolling past hero, hide at footer
    const hero = document.getElementById('Hero');
    const stickyCta = document.getElementById('StickyCta');
    const footer = document.querySelector('.site-footer');
    if (hero && stickyCta && footer) {
      window.addEventListener('scroll', () => {
        const heroBottom = hero.getBoundingClientRect().bottom;
        const footerTop = footer.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        
        // Hide if we haven't scrolled past hero
        if (heroBottom >= 0) {
          stickyCta.style.display = 'none';
          stickyCta.classList.remove('hidden-at-bottom');
        } 
        // Hide if footer is visible in the viewport
        else if (footerTop < windowHeight) {
          stickyCta.classList.add('hidden-at-bottom');
        } 
        // Show otherwise
        else {
          stickyCta.style.display = 'flex';
          stickyCta.classList.remove('hidden-at-bottom');
        }
      }, { passive: true });
    }